module.exports = __webpack_public_path__ + "img/12.056d931b.jpg";